import { render, staticRenderFns } from "./AddDivision.vue?vue&type=template&id=7bb9d2a6&"
import script from "./AddDivision.vue?vue&type=script&lang=js&"
export * from "./AddDivision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports